import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Popover, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import IntlMessages from '../../components/utility/intlMessages';
import authAction from '../../redux/auth/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import DvFontAwesome from "../../components/uielements/dvFontAwesome";

const { logout } = authAction;

class TopbarUser extends Component {
  state = {
    open: false,
    clinic: {
      name: '',
      tooltip: ''
    }
  };

  handleOpenChange = () => {
    this.setState({ open: !this.state.open });
  }

  getPopoverContent = () => {
    return (
      <TopbarDropdownWrapper className="isoUserDropdown">
        <span className="isoDropdownLink" onClick={this.props.logout}>
          <IntlMessages id="topbar.logout" />
        </span>
      </TopbarDropdownWrapper>
    );
  }

  getUserAvatar = () => {
    return (
      <DvFontAwesome
        icon="user"
        size="2x"
        onClick={this.handleOpenChange}
        className="menuIcon"
        style={{ color: "white"}}
      />
    );
  }

  render() {
    return (
      <Popover
        content={this.getPopoverContent()}
        trigger="click"
        open={this.state.open}
        onOpenChange={this.handleOpenChange}
        placement="bottomRight"
        overlayClassName={'userAvatarPopover'}
      >
        {this.getUserAvatar()}
        <Tooltip
          title={this.state.clinic.tooltip}
          placement="bottomRight" >
          <div style={{
            fontSize: '11px',
            position: "absolute",
            lineHeight: '1px',
            whiteSpace: 'nowrap',
            right: 2,
            marginBottom: 0,
            top: 58,
            cursor: 'default'
          }}
          >
            {this.state.clinic.name}
          </div>
        </Tooltip>
      </Popover>
    );
  }
}

const mapActionsToProps = {
  logout
};

TopbarUser.propTypes = {
  logout: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
  };
}

const connectedApp = connect(mapStateToProps, mapActionsToProps)(TopbarUser);
export default connectedApp;
